import { Typography, Box, Paper } from "@mui/material";
import { UsersPermissions } from "./UsersPermissions";

export const Permissions = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: "grey.100",
        minHeight: "100vh",
        p: 10,
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            color: "#00719C",
            fontWeight: 500,
            fontSize: "1.375rem",
          }}
        >
          Настройка пермишенов
        </Typography>

        <Box
          sx={{
            height: 0.25,
            bgcolor: "grey.200",
            width: "100%",
            mt: 4,
          }}
        />
      </Box>

      <UsersPermissions />
    </Paper>
  );
};
